import styled from 'styled-components';
import { media, color, font } from 'style';

export default {
  BulletsListContainer: styled.div`
    display: flex;
    gap: 40px;
    flex-direction: column;

    ${media.md`
      flex-direction: row;
    `}
  `,
  SectionContainer: styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    grid-column-gap: 20px;
    grid-row-gap: 23px;
    align-items: center;
  `,
  Title: styled.h3`
    margin: 0;
    grid-column: 2/3;
    font-size: 18px;
    line-height: 25px;
    font-weight: 700;
  `,
  BulletIcon: styled.img`
    width: 25px;
    margin: 0;
  `,
  OrderIndicator: styled.div`
    width: 50px;
    height: 50px;
    min-width: 50px;
    min-height: 50px;
    border-radius: 50%;
    color: ${color.white};
    background-color: ${color.hmPurple4};
    line-height: 50px;
    text-align: center;
    font-size: ${font.size.xxLarge};
  `,
  BulletText: styled.p`
    margin: 0;
    max-width: 350px;
  `,
};
